import * as React from 'react';
import { VirtualTableLayoutBlockProps } from '../../types';
import { VirtualRowLayout } from './virtual-row-layout';

// tslint:disable-next-line: max-line-length
export class VirtualTableLayoutBlock extends React.PureComponent<VirtualTableLayoutBlockProps, any> {
  render() {
    const {
      collapsedGrid,
      rowRefsHandler,
      bodyComponent: Body,
      cellComponent,
      rowComponent,
    } = this.props;

    return (
      <Body>
        {collapsedGrid.rows.map((visibleRow) => {
          const { row, cells = [] } = visibleRow;

          return (
            <VirtualRowLayout
              key={row.key}
              row={row}
              cells={cells}
              forwardedRef={ref => rowRefsHandler(row, ref)}
              rowComponent={rowComponent}
              cellComponent={cellComponent}
            />
          );
        })}
        </Body>
    );
  }

}
